import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { GlobalFunctionsService } from '../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl?: string;
  currentUser: User;
  users: User[] = [];
  currentUserVAR: any;
  soft: any;
  logoutReason = '';
  clientBuild = '';
  serverBuild = '';
  isVersionMismatch = false;

  constructor(
    private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        public gfunc: GlobalFunctionsService,
        public toastr: HotToastService,
  ) {
     this.currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string as string);
  }

  ngOnInit() {
              this.logoutReason = this.route.snapshot.queryParams['reason'] || '';
              this.clientBuild = (this.route.snapshot.queryParams['clientBuild'] || '').trim();
              this.serverBuild = (this.route.snapshot.queryParams['serverBuild'] || '').trim();
              this.isVersionMismatch = this.logoutReason === 'version-mismatch';


              // this.soft = this.route.snapshot.queryParams.get('soft')

              // reset login status
              this.logout();

              // console.log(this.currentUser);
              // get return url from route parameters or default to '/'
              this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';






  }



  logout() {
      this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser') as string);

      if (this.currentUserVAR) {
        let log_name = 'User Logout  ' + this.gfunc.sessionUserId + ' USER :: '
        + ' - ' + this.gfunc.sessionUsername + ' (' + this.gfunc.sessionUserFullName  + ' ' + this.gfunc.sessionUserLevel +  ' ) ';

            // insert log
          let log_data = {
              // log_id: null,
              log_content: JSON.stringify(sessionStorage.getItem('currentUser')), // inserts the entire JSON action into mysql cell
              log_action: 'user_logout', // automated / updated / created / uploaded / link_created / sent / accessed
              log_type_id: 30, // see datatable system_log_types (12 = subject_attempt)
              // created_by: this.sessionUserId,
              created_by: this.gfunc.sessionUserId,
              created_date: this.gfunc.today,
              subject_id: null,
              job_id: null,
              job_reference_number: null,
              file_number: null,
              reference_number: null,
              subject_number: null,
              brand_id: this.gfunc.sessionBrandId,
              user_id: this.gfunc.sessionUserId,
          
              created_level: this.gfunc.sessionUserLevel, // staff
              brand_type_id: this.gfunc.sessionBrandTypeId,
              subject_com_type_id: null,
              subject_template_doc_id: null,
              log_name: log_name,
            file_id: null,
            agent_id: null,
            invoice_id: null,
            };

        this.gfunc.createSystemLog(log_data);
      }

   setTimeout(() => {  
    console.log("A Simple Pause!");


    // remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('sessionBrandName');
    sessionStorage.removeItem('sessionBrandTypeId');


    }, 4000);


}


}
